module.exports = __webpack_public_path__ + "static/media/image_03.1416845c.jpg";